import "./BasicContactPage.css";

function normalizeHref(value = "") {
 const v = value.trim();
 if (!v) return "";

 if (
  v.startsWith("http://") ||
  v.startsWith("https://") ||
  v.startsWith("mailto:") ||
  v.startsWith("tel:")
 ) {
  return v;
 }

 if (v.includes("@") && !v.includes(" ")) {
  return `mailto:${v}`;
 }

 return v;
}

function BasicContactPage({ organization, page, settings }) {
 const org = organization || {};
 const content = page?.content || {};
 const theme = settings || {};

 const title = content.title?.trim() || "League Contact";
 const contactName = content.contact_name?.trim() || "League Commissioner";
 const contactEmail = content.contact_email?.trim() || "";
 const contactPhoneLabel = content.contact_phone_label?.trim() || "Text Message Number";
 const contactPhone = content.contact_phone?.trim() || "";
 const introText = content.intro_text?.trim() || "";

 const emailHref = contactEmail ? normalizeHref(contactEmail) : "";
 const phoneHref = contactPhone ? `tel:${contactPhone.replace(/[^+\d]/g, "")}` : "";

 const themeMode = theme.theme_mode === "light" ? "light" : "dark";
 const primaryColor = theme.primary_color || "#111111";
 const accentColor = theme.accent_color || "#d4af37";

 return (
  <div
   className={`basic-contact-page ${themeMode}`}
   style={{
    "--bcp-primary": primaryColor,
    "--bcp-accent": accentColor,
   }}
  >
   <div className="bcp-container">
    <h1>{title}</h1>

    <section className="bcp-card">
     {contactName ? <h3>{contactName}</h3> : null}

     {emailHref ? (
      <a href={emailHref}>{contactEmail}</a>
     ) : null}

     {contactPhone ? (
      <>
       <h3>{contactPhoneLabel}</h3>
       <a href={phoneHref || "#"}>{contactPhone}</a>
      </>
     ) : null}

     {introText ? <p className="bcp-intro">{introText}</p> : null}

     {!contactName && !contactEmail && !contactPhone ? (
      <p className="bcp-empty">
       Contact information for {org.name || "this organization"} is coming soon.
      </p>
     ) : null}
    </section>
   </div>
  </div>
 );
}

export default BasicContactPage;